import {
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  HostBinding,
  Input,
  NgModule,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

/*
Add ignoreExternLink attribute to a link for ignore external icon
**/
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'a:not([ignoreExternLink]):not([routerLink])',
})
export class ExternalLinkDirective implements OnInit {
  @HostBinding('rel')
  @Input()
  rel = 'noopener';

  @HostBinding('target')
  @Input()
  target = '_blank';

  constructor(private readonly viewContainer: ViewContainerRef, private resolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    const factory: ComponentFactory<MatIcon> = this.resolver.resolveComponentFactory(MatIcon);
    const iconComponent: ComponentRef<MatIcon> = this.viewContainer.createComponent(factory);
    iconComponent.instance.svgIcon = 'external_link';

    const iconComponentNativeElement: HTMLElement = <HTMLElement>iconComponent.location.nativeElement;
    iconComponentNativeElement.classList.add('icon-external-link');
    this.viewContainer.element.nativeElement.appendChild(iconComponentNativeElement);
  }
}

@NgModule({
  declarations: [ExternalLinkDirective],
  exports: [ExternalLinkDirective],
})
export class ExternalLinkDirectiveModule {}
